
const initialState = {
  user: false,
  option: {
    education: [],
    nurseReason: [],
    bank: [],
    workAgreement: [],
    position: [],
  },
  location: { latitude: null, longitude: null },
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "SETUSER":
      return { ...state, user: action.payload };
    case "CLEARUSER":
      return { ...state, user: false };
    case "SETCONFIG":
      return { ...state, option: action.payload };
    case "CLEARCONFIG":
      return { ...state,option: { education: [], nurseReason: [], bank: [], workAgreement: [] } };
    case "SETLOCATION":
      return { ...state, location: action.payload };
    case "CLEARLOCATION":
      return { ...state, location: false };
    default:
      return state;
  }
};
